import { render, staticRenderFns } from "./DictionaryData.vue?vue&type=template&id=64565bb1&scoped=true"
import script from "./DictionaryData.vue?vue&type=script&lang=js"
export * from "./DictionaryData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64565bb1",
  null
  
)

export default component.exports